// 首页的接口
import request from '@/utils/request'

// 分页查询我的二级机构
export function pageMySecondJg(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/pageMySecondJg',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 二级机构详情
export function secondJgDetail(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/secondJgDetail',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}

// 二级机构保存
export function saveSecondJg(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/saveSecondJg',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 二级机构修改
export function updateSecondJg(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/updateSecondJg',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 二级机构删除
export function deleteSecondJg(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/deleteSecondJg',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 批量导入
export function postSecondUpload(data) {
  return request({
    url: '/sc/ticketMain/api/factJgjbxxb/secondExcelRead',
    method: 'post',
    data: data,
    headers: {
      isToken: true
    }
  })
}

// 查询当前机构的下属机构发布的所有服务
export function countMyThirdlyJg(data) {
  return request({
    url: '/sc/ticketMain/api/factFwjbxxb/pageMyChildList',
    method: 'get',
    params: data,
    headers: {
      isToken: true
    }
  })
}
